export default "__VITE_ASSET__ddf126c8__"